// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"f36fb662","845":"488d90c3"}[chunkId] + ".chunk.js";
};